import IconClose from '@apollo/icons/default/IconClose.svg';
import IconSearch from '@apollo/icons/default/IconSearch.svg';
import { IconButton, Input } from '@apollo/orbit';
import React from 'react';

import { useDebounce } from 'src/app/account/graphOnboarding/hooks/useDebounce';

type SearchProps = {
  className?: string;
  onSearch: (search: string) => void;
  placeholderText: string;
  inputValue: string;
  onInputChange: (arg: string) => void;
  onClear: () => void;
};

export const SearchFilter = ({
  className,
  onSearch,
  placeholderText,
  inputValue,
  onInputChange,
  onClear,
}: SearchProps) => {
  const inputRef = React.useRef<HTMLInputElement>(null);

  const handleOnSearch = useDebounce(() => {
    onSearch(inputValue);
  });

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const currentSearchString = event.target.value;
    onInputChange(currentSearchString);
    handleOnSearch();
  };

  return (
    <Input
      className={className}
      ref={inputRef}
      placeholder={placeholderText}
      value={inputValue}
      onInput={handleInputChange}
      leftElement={<IconSearch className="pointer-events-none" />}
      rightElement={
        inputValue ? (
          <IconButton
            size="sm"
            data-testid="clear-search"
            aria-label="Clear search"
            variant="hidden"
            className="text-disabled"
            onClick={() => {
              onInputChange('');
              onSearch('');
              inputRef.current?.focus();
              onClear();
            }}
          >
            <IconClose />
          </IconButton>
        ) : null
      }
    />
  );
};
